<template lang="pug">
#minigame.modal.modal-bottom.fade.modal-minigame(tabindex='-1' role='dialog' aria-labelledby='minigame' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.m-0(role='document')
    .modal-content
      button.close(type='button' data-dismiss='modal' aria-label='Close' @click="closeGame2")
        span(aria-hidden='true') &times;
      .mini-game-title
        img(src='images/minigame_title.png')
      .modal-body
        #mini-widget
          iframe(v-if="play2", :src="miniUrl" style="height:100%; width:100%; border:none;")
          div(v-else @click="playGame2('0')")
            img.img-fluid(src='images/minigame_sample.jpg')

</template>

<script>
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-game.js";
import mixinExt from "@/library/mixinExt.js";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/library/_xhr-ext";

export default {
  mixins: [mixinExt],
  data() {
    return {
      play2: false,
      miniUrl: "/minigame"
    }
  },
  destroyed() {
    $("#minigame").off("shown.bs.modal", this.playGame2);
    $("#minigame").off("hidden.bs.modal", this.closeGame2);
  },
  mounted() {
    $("#minigame").on("shown.bs.modal", this.playGame2);
    $("#minigame").on("hidden.bs.modal", this.closeGame2);
  },
  methods: {
    resizeWidget(e) {
      // var r1 = 398 / 436;
      var r1 = 160 / 340;
      // if (e == 1) {
      //   r1 = 322 / 414;
      // }
      var e1 = $("#mini-widget");
      // console.log($("#mini-widget").width())
      e1.height(e1.width() * r1);
    },
    playGame2(e) {
      this.play2 = false;
      this.$nextTick(() => {
        this.play2 = true;
        this.resizeWidget(0);
      });
    },
    closeGame2() {
      this.play2 = false;
    }
  }
}
</script>
